import { render, staticRenderFns } from "./CustomerSetting.vue?vue&type=template&id=a32db7ee&scoped=true"
import script from "./CustomerSetting.vue?vue&type=script&lang=ts"
export * from "./CustomerSetting.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSetting.vue?vue&type=style&index=0&id=a32db7ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32db7ee",
  null
  
)

export default component.exports